// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"205":"favorites","489":"characters","942":"not-found"}[chunkId] + "." + {"205":"bfdcfb63","489":"2410047b","942":"75e7fafe"}[chunkId] + ".css";
};